/**
 * Client Portal API Helper
 * Handles authenticated API calls for the client portal
 */

const API_BASE = process.env.REACT_APP_API_URL || '';

export function getToken() {
  return localStorage.getItem('ta_client_token');
}

export function getRefreshToken() {
  return localStorage.getItem('ta_client_refresh');
}

export function setTokens(token, refreshToken) {
  localStorage.setItem('ta_client_token', token);
  if (refreshToken) localStorage.setItem('ta_client_refresh', refreshToken);
}

export function clearTokens() {
  localStorage.removeItem('ta_client_token');
  localStorage.removeItem('ta_client_refresh');
  localStorage.removeItem('ta_client_data');
}

export function getClientData() {
  try {
    return JSON.parse(localStorage.getItem('ta_client_data') || 'null');
  } catch {
    return null;
  }
}

export function setClientData(data) {
  localStorage.setItem('ta_client_data', JSON.stringify(data));
}

export async function clientFetch(path, options = {}) {
  const token = getToken();

  const res = await fetch(`${API_BASE}/api${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });

  // Handle token expiry — try refresh
  if (res.status === 401 && getRefreshToken()) {
    const refreshRes = await fetch(`${API_BASE}/api/client/auth/refresh`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refreshToken: getRefreshToken() }),
    });

    if (refreshRes.ok) {
      const data = await refreshRes.json();
      setTokens(data.token);

      // Retry original request
      return fetch(`${API_BASE}/api${path}`, {
        ...options,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${data.token}`,
          ...options.headers,
        },
      });
    }

    // Refresh failed — redirect to login
    clearTokens();
    window.location.href = '/client/login';
    return res;
  }

  return res;
}

export function navigate(path) {
  window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function logout() {
  clientFetch('/client/auth/logout', { method: 'POST' }).catch(() => {});
  clearTokens();
  window.location.href = '/client/login';
}
